import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./configcat.service";
import * as i2 from "@imaginelearning/web-api-core";
export class FeatureFlagService {
    constructor(configCatService, environment) {
        this.configCatService = configCatService;
        this.environment = environment;
    }
    // Evaluates a feature flag using ConfigCat
    evaluateFlag(flagKey, entityContext) {
        // Always check environment variable for the migration switch
        console.log(`[FeatureFlagService]: Using ConfigCat for flag: ${flagKey}`);
        return this.configCatService.evaluateFlag(flagKey, entityContext).pipe(catchError(error => {
            console.error('[FeatureFlagService]: Error occurred:', error);
            return of(false);
        }));
    }
    ngOnDestroy() {
        this.configCatService.ngOnDestroy();
    }
    static { this.ɵfac = function FeatureFlagService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FeatureFlagService)(i0.ɵɵinject(i1.ConfigCatService), i0.ɵɵinject(i2.Environment)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FeatureFlagService, factory: FeatureFlagService.ɵfac, providedIn: 'root' }); }
}
